import React, { useState, useEffect } from "react";
import { Container, FormControl, Select, Alert, Snackbar, MenuItem, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Switch} from '@mui/material';
import { useNavigate } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { orgCreate, resetOrg } from 'api/org';
import { useOrgCreateMutation, useOrgCognitoMutation } from 'services/org'
import { v4 as uuidv4 } from 'uuid'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

var stateList = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
]

const OrgCreate = (props) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const regexCode = /^[a-zA-Z0-9]{6,}$/;
    const navi = useNavigate();
    const dispatch = useDispatch();
    const org = useSelector(state=>state.org.create);
    const [disableButton, setDisableButton] = useState(false);
    const [sb, setSB] = useState({open: false, message: '', duration: 3000});
    const [validEmail, setValidEmail] = useState(false);
    const [invalidEmail, setInValidEmail] = useState(false);
    const [emailStatus, setEmailStatus] =  useState('');

    const [ orgCreateMutation, { isLoading: isUpdating }] = useOrgCreateMutation(); 
    const [ orgCognitoMutation, { isLoading: isCognitoUpdating }] = useOrgCognitoMutation(); 

    const handleCancel = () =>{
        navi("/orgs/list")
    }

    useEffect(()=>{
        dispatch(resetOrg())
    }, [])

    
    const onEmailChange = (event) =>{
        dispatch(orgCreate({username: event.target.value, email: event.target.value}))
    }

    const onEmailBlur = (event) =>{
        
        if(regex.test(event.target.value)){
            setInValidEmail(false);
            setEmailStatus('')
            setValidEmail(true);
        } else {
            setInValidEmail(true);
            setEmailStatus('Invalid E-Mail')
            setValidEmail(false);
        }
    }

    const onPhoneChange = (value) =>{
        var phone = value;
        var phone_number = `+1${value}`;
        if(org.phone.length<11){
            dispatch(orgCreate({phone: phone}));
            dispatch(orgCreate({phone_number: phone_number}));
        }
    }

    const onNameChange = (value) =>{
        dispatch(orgCreate({name: value}));
        dispatch(orgCreate({given_name: value}));
        dispatch(orgCreate({family_name: 'LLC'}));
    }

    const onZipChange = (value) =>{
        if(value.length<6){
            dispatch(orgCreate({zip: value}));
        }
    }

    const onStatusChange = (event) =>{
        dispatch(orgCreate({status: event.target.checked}))
    }

    const handleClose = () => {
        setSB({...sb, open: false});
      };

    const onSave = () =>{
        setDisableButton(true);
        orgCognitoMutation(org)
        .unwrap()
        .then(result=>{
            var id = uuidv4();
            var record = {
                ...org,
                id: id
            }
            orgCreateMutation(record)
            .unwrap()
            .then(result=>{
                setTimeout(()=>{
                    setDisableButton(false);
                    navi("/orgs/list");  
                }, 5000)
            })
            .catch(err=>{
                setDisableButton(false);
            })
        })
        .catch(err=>{
            setSB({...sb, open: true, message: err.message});
            setDisableButton(false);
        })

        
    }

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: "Create New User", description: "Add new User"}} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton?<LinearProgress />:''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={(event)=>onNameChange(event.target.value)}
                                value={org.name || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail / UserName</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onEmailChange}
                                value={org.username || ''}  
                                helperText={emailStatus}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {validEmail?<DoneIcon color="primary" />:invalidEmail?<CloseIcon color="warning" />:''}
                                        </InputAdornment>
                                    )
                                }}
                                onBlur={onEmailBlur}
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onPhoneChange(event.target.value)}
                                value={org.phone || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Address</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={(event)=>dispatch(orgCreate({address: event.target.value}))}
                                value={org.address || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">City</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={(event)=>dispatch(orgCreate({city: event.target.value}))}
                                value={org.city || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">State</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>
                                
                                <Select
                                    value={org.state || ''}
                                    onChange={(event)=>dispatch(orgCreate({state: event.target.value}))}
                                >
                                    {stateList?.map((o, i)=>
                                        <MenuItem key={i} value={o.name}>{`${o.name}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Zip</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onZipChange(event.target.value)}
                                value={org.zip || ''}  
                            />
                        </Grid>
                    </Grid>

                    

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Switch checked={org?.status} onChange={(event)=>onStatusChange(event)}/>
                        </Grid>
                    </Grid>
                    
                    <CardActions sx={{padding: "15px"}}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Container>
            <Snackbar
                color='error'
                open={sb.open}
                autoHideDuration={sb.duration}
                onClose={handleClose}
                message={sb.message}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                onClose={handleClose}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
                >
                    {sb.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )

    
}

export default OrgCreate;